import { useMemo } from 'react';
import { useBindViewer } from '../../hooks/useBindViewer';
import {
  canCreateProgramContent,
  canDeleteProgramMember,
  canDownloadProgramReport,
  canInviteProgramMembers,
  canManageProgram,
  canRateProgramObjectProfile,
  canSeeFuturePosts,
  canUnsubscribe,
  canViewAdminDashboardPrograms,
  canViewProgram,
  canViewProgramMembers,
  canViewRating,
  hasJoinedProgram,
  hasUserSentJoinRequest,
  isMemberOfProgram,
  joinedAsUser,
} from '../permissions';

export const useProgramsPermissions = () => {
  const bindViewer = useBindViewer();

  return useMemo(
    () => ({
      canCreateProgramContent: bindViewer(canCreateProgramContent),
      canDeleteProgramMember: bindViewer(canDeleteProgramMember),
      canDownloadProgramReport: bindViewer(canDownloadProgramReport),
      canInviteProgramMembers: bindViewer(canInviteProgramMembers),
      canManageProgram: bindViewer(canManageProgram),
      canRateProgramObject: bindViewer(canRateProgramObjectProfile),
      canSeeFuturePosts: bindViewer(canSeeFuturePosts),
      canUnsubscribe: bindViewer(canUnsubscribe),
      canViewAdminDashboardPrograms: bindViewer(canViewAdminDashboardPrograms),
      canViewProgram: bindViewer(canViewProgram),
      canViewProgramMembers: bindViewer(canViewProgramMembers),
      canViewRating: bindViewer(canViewRating),
      hasJoinedProgram: bindViewer(hasJoinedProgram),
      hasUserSentJoinRequest: bindViewer(hasUserSentJoinRequest),
      isMemberOfProgram: bindViewer(isMemberOfProgram),
      joinedAsUser: bindViewer(joinedAsUser),
    }),
    [bindViewer],
  );
};
